let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("hPPMU")).then(() => parcelRequire('aMyAY'));